import styled, { keyframes } from "styled-components";

interface LoadingOverlayProps {
  /** 스피너 아래 표시할 안내 문구 */
  text: string;
}

/**
 * 비동기 작업(저장·생성 등) 진행 중 전체 화면 오버레이.
 * 어두운 반투명 백드롭 위에 밝은(흰색) 스피너 + 텍스트, 작업 동안 입력을 가볍게 막는다.
 * 완료/실패는 호출부에서 토스트로 안내. 페이지 최초 로딩용 PageSpinner 와는 용도가 다르다.
 *
 * 사용처: 분석 초안 'Key 자동 입력'(KeyGenLoadingOverlay), 카메라 매핑 '저장 중'(SaveLoadingOverlay).
 */
export function LoadingOverlay({ text }: LoadingOverlayProps) {
  return (
    <Backdrop>
      <Spinner />
      <Text>{text}</Text>
    </Backdrop>
  );
}

// 스피너/텍스트 색 — 밝은 무채색
const LOADER_COLOR = "rgba(255, 255, 255, 0.92)";

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(0, 0, 0, 0.8);
`;

const spin = keyframes`
  100% { transform: rotate(1turn); }
`;

const SIZE = 40;
const THICKNESS = 6;

const Spinner = styled.div`
  width: ${SIZE}px;
  height: ${SIZE}px;
  border-radius: 50%;
  background:
    radial-gradient(farthest-side, ${LOADER_COLOR} 94%, #0000)
      top / ${THICKNESS}px ${THICKNESS}px no-repeat,
    conic-gradient(#0000 30%, ${LOADER_COLOR});
  mask: radial-gradient(farthest-side, #0000 calc(100% - ${THICKNESS}px), #000 0);
  animation: ${spin} 1s infinite linear;
`;

const Text = styled.div`
  font-family: Pretendard Variable, Pretendard, sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: ${LOADER_COLOR};
`;
